export const roomTypes = {
  tile: 'TILE',
  wallpaper: 'WALLPAPER',
};
